<template>
    <div class="resident-warpper">
        <div class="bg-white">
            <div class="flex align-center margin-right-sm ">
                <template  v-if="[3].includes(user.power)">
                    <span>社区：</span>
                    <el-select v-model="xiangmu_id" placeholder="请选择社区" filterable clearable>
                        <el-option
                            v-for="item in projectList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </template>
                <span>状态：</span>
                <el-select v-model="state" placeholder="请选择状态" filterable clearable>
                    <el-option
                        v-for="item in [
                            {name:'全部',id:''},
                            {name:'兑换中',id:1},
                            {name:'已兑换',id:2},
                        ]"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                 <span>时间：</span>
                <el-date-picker
                    v-model="time"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                />
                <el-button type="primary" @click="hanldSearch">搜索</el-button>
            </div>
            <div class="flex align-center justify-between margin-tb-sm">
                <div>
                    共{{ total }}条数据
                </div>
                <div>
                    <el-button
                        type="warning"
                        @click="exportList"
                    >导出
                    </el-button>
                </div>
            </div>

            <el-table
                :data="residentList"
                header-row-class-name="table-header"
                row-class-name="table-row"
                alig="center"
                border
                style="width: 100%">
                <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
                <el-table-column label="兑换人" prop="name"></el-table-column>
                <el-table-column label="商品名称" prop="product_name"></el-table-column>
                <el-table-column label="社区" prop="xiangmu_name"></el-table-column>
                <el-table-column label="时间" prop="update_time"></el-table-column>
                <el-table-column label="状态" prop="state"></el-table-column>
            </el-table>
            <el-pagination
                v-if="residentList.length > 0"
                class="page-all"
                background
                @current-change="getResidentList"
                :current-page.sync="page"
                :page-size="limit"
                layout="prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {exportProductOrder, productOrder} from "@/api/weilao";
import {getXiangMuList} from "@/api/common";

export default {
    name: "shopping",
    components: {},
    data() {
        return {
            projectList:[],
            state: '',//状态 1兑换中 2已兑换
            time:[],  //时间
            xiangmu_id: '',
            page: 1,
            limit: 10,
            total: 0,
            residentList: [],
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.$emit("setIndex", '/home/shopping', "双暖为老 / 商品管理 / 兑换记录", true);
        this.getResidentList()
        this.getXiangMuList()
    },
    methods: {
        //  获取当前人员下的小区
        async getXiangMuList() {
            const project = await getXiangMuList()
            this.projectList = [{name:'全部',id:0},...project.data]
        },
        //  获取商品列表
        async getResidentList() {
            let _data = await productOrder(
                this.xiangmu_id,
                this.state,
                this.time && this.time.length ? this.time[0] : '',
                this.time && this.time.length ? this.time[1] : '',
                this.page,
                this.limit,
            )
            this.residentList = _data.data
            this.total = _data.total_number
        },
        hanldSearch() {
            this.page = 1
            this.getResidentList()
        },
        async exportList(){
            let _state = await exportProductOrder(this.xiangmu_id,
                this.state,
                this.time && this.time.length ? this.time[0] : '',
                this.time && this.time.length ? this.time[1] : '',)
            let blob = _state.data
            var downloadElement = document.createElement('a');
            var href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.style.display = 'none';
            downloadElement.href = href;
            downloadElement.setAttribute('download', '兑换记录.xls');
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
        },
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">

</style>
